module.exports = __webpack_public_path__ + "static/media/KayaandSange.c0874291.png";